import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { PaInfoBlockComponent } from '../../../../shared/ui-kit/pa-info-block/pa-info-block.component';
import { PaButtonComponent } from 'src/app/shared/ui-kit/pa-button/pa-button.component';

@Component({
  selector: 'app-info-block-view',
  standalone: true,
  imports: [CommonModule, PaInfoBlockComponent, PaButtonComponent],
  templateUrl: './info-block-view.component.html',
  styleUrls: ['./info-block-view.component.scss'],
 
})
export class InfoBlockViewComponent {
  demoLongBlockTitle =
    'Очень длинный заголовок информационного блока, который на узкой ' +
    'ширине обрезается многоточием, полный текст виден при наведении ' +
    'на заголовок';

  headerSingleEdit: MenuItem[] = [
    {
      label: 'Изменить',
      icon: 'pi pi-pencil',
      command: () => this.onClick(),
    },
  ];

  headerManyActions: MenuItem[] = [
    {
      label: 'Дублировать',
      icon: 'pi pi-copy',
      command: () => this.onClick(),
    },
    {
      label: 'Экспорт в файл',
      icon: 'pi pi-download',
      command: () => this.onClick(),
    },
    {
      label: 'Удалить',
      icon: 'pi pi-trash',
      command: () => this.onClick(),
    },
  ];

  headerComboMenu: MenuItem[] = [
    {
      label: 'Обновить',
      icon: 'pi pi-refresh',
      command: () => this.onClick(),
    },
    {
      label: 'Настройки',
      icon: 'pi pi-cog',
      command: () => this.onClick(),
    },
  ];

  headerSingleArchive: MenuItem[] = [
    {
      label: 'В архив',
      icon: 'pi pi-inbox',
      command: () => this.onClick(),
    },
  ];

  onClick(): void {
    console.log('onClick');
  }
}
